import React, { useState } from "react";
import { i18n } from "../../translate/i18n";
import { Avatar, CardHeader, Grid, TextField, Input, InputAdornment, InputLabel } from "@material-ui/core";
import { TagsKanbanContainer } from "../TagsKanbanContainer";
import resolveContactPictureUrl from "../../helpers/resolveContactPictureUrl";

const TicketInfo = ({ contact, ticket, onClick }) => {
	const [amount, setAmount] = useState("");

	const renderCardReader = () => {
		return (
			<CardHeader
				onClick={onClick}
				style={{ cursor: "pointer", display: 'flex', alignItems: 'center', padding: '8px 12px' }}
				titleTypographyProps={{ noWrap: true, style: { color: '#ffffff', fontWeight: 700, fontSize: 18, lineHeight: '20px' } }}
				subheaderTypographyProps={{ noWrap: true, style: { color: '#ffffff', fontSize: 13, lineHeight: '16px' } }}
				avatar={<Avatar src={resolveContactPictureUrl(contact)} alt="contact_image" style={{ width: 48, height: 48 }} />}
				title={`${contact?.name || '(sem contato)'} #${ticket.id}`}
				subheader={
					ticket.user &&
					`${i18n.t("messagesList.header.assignedTo")} ${ticket.user.name}`
				}

			/>
		);
	}

	const handleChange = (event) => {
		const value = event.target.value;

		setAmount(value);
	}


	return (
		<React.Fragment>
			<Grid container alignItems="center" spacing={10}>
				{/* Conteúdo do contato à esquerda */}
				<Grid item xs={6}>
					{renderCardReader()}
				</Grid>
			</Grid>
		</React.Fragment>
	);
};

export default TicketInfo;
